import { Checkbox } from '../../../components';
import * as React from 'react';
import { CenterModel } from '../types';

interface FulfillmentOptionsProps {
  data: CenterModel;
  onChange(data: CenterModel);
}

export class FulfillmentOptions extends React.Component<FulfillmentOptionsProps, {}> {
  onChangePickup = () => {
    this.props.onChange({
      ...this.props.data,
      options: {
        pickup: !this.props.data.options.pickup,
        delivery: this.props.data.options.delivery,
      },
    });
  };

  onChangeDelivery = () => {
    this.props.onChange({
      ...this.props.data,
      options: {
        pickup: this.props.data.options.pickup,
        delivery: !this.props.data.options.delivery,
      },
    });
  };

  render() {
    return (
      <div className='fulfillment-center-modal-fulfillment-options'>
        <div className='fulfillment-center-modal-fulfillment-options-row'>
          <Checkbox isChecked={this.props.data.options.pickup} onClick={this.onChangePickup} />
          <span onClick={this.onChangePickup} className='fulfillment-center-modal-fulfillment-options-label'>
            Pick-up
          </span>
        </div>
        <div className='fulfillment-center-modal-fulfillment-options-row'>
          <Checkbox isChecked={this.props.data.options.delivery} onClick={this.onChangeDelivery} />
          <span onClick={this.onChangeDelivery} className='fulfillment-center-modal-fulfillment-options-label'>
            Delivery
          </span>
        </div>
      </div>
    );
  }
}
